<script setup lang="ts">
  import { useFlowConfigStore } from '@/store/flow-config.store'
  import { useFlowStore } from '@/store/flow.store'
  import { UiButton, FormFieldContainer } from '@logistiek-zonder-papier/lzp-library'
  import VueJsonPretty from 'vue-json-pretty'
  import 'vue-json-pretty/lib/styles.css'
  import MimicModal from '@/components/form-wizard/MimicModal.vue'
  import { debounce } from '@/utils/debounce'

  const flowStore = useFlowStore()
  const configStore = useFlowConfigStore()

  const showDeviceIdModal = defineModel<boolean>('showDeviceIdModal', { default: false })
  const appUserEmailSearch = defineModel<string>('appUserEmailSearch', { default: '' })
  const deviceIds = defineModel<string[]>('deviceIds', { default: () => [] })

  const showAppUserIdModal = defineModel<boolean>('showAppUserIdModal', { default: false })
  const appUserIdSearch = defineModel<string>('appUserIdSearch', { default: '' })
  const appUserIds = defineModel<string[]>('appUserIds', { default: () => [] })

  async function openDeviceIdModal() {
    showDeviceIdModal.value = true
  }

  async function openAppUserIdModal() {
    showAppUserIdModal.value = true
  }

  const updateSearchDevices = debounce(async () => {
    deviceIds.value = await configStore.searchDevices(appUserEmailSearch.value)
  }, 500)

  const updateSearchAppUsers = debounce(async () => {
    appUserIds.value = await configStore.searchAppUsers(appUserIdSearch.value)
  }, 500)
</script>

<template>
  <div class="scroll json-container">
    <FormFieldContainer label="Koppelingen">
      <div class="connect-container">
        <UiButton
          variant="prominent"
          label="Device"
          class="connect-button"
          :class="{ connected: configStore.mimicDeviceId }"
          @click="openDeviceIdModal"
        />
        <UiButton
          variant="prominent"
          label="App User"
          class="connect-button"
          :class="{ connected: configStore.mimicUserId }"
          @click="openAppUserIdModal"
        />
      </div>
    </FormFieldContainer>
    <FormFieldContainer label="Data">
      <vue-json-pretty :data="flowStore.flowData" />
    </FormFieldContainer>
  </div>

  <MimicModal
    label="Koppel Device"
    v-model:show="showDeviceIdModal"
    v-model:search="appUserEmailSearch"
    :items="deviceIds"
    @search="updateSearchDevices()"
    @select="
      deviceId => {
        configStore.setMimicDeviceId(deviceId)
        flowStore.setValue('deviceId', deviceId)
        showDeviceIdModal = false
      }
    "
  />

  <MimicModal
    label="Koppel App User"
    v-model:show="showAppUserIdModal"
    v-model:search="appUserIdSearch"
    :items="appUserIds"
    @search="updateSearchAppUsers()"
    @select="
      appUserId => {
        configStore.setMimicUserId(appUserId)
        flowStore.setValue('userId', appUserId)
        showAppUserIdModal = false
      }
    "
  />
</template>

<style scoped>
  .scroll {
    margin-top: 1rem;
    overflow-y: scroll;
    scrollbar-width: none;
  }

  .json-container {
    border: 1px solid var(--colours-grey-3);
    box-shadow: 1px 1px 1px 1px var(--colours-grey-3);
    margin-bottom: 1.5rem;
    padding: 1rem;
    border-radius: 0.75rem;
  }

  .connect-container {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    width: 100%;
    justify-content: space-between;
  }

  .connect-button {
    flex-grow: 1;
  }

  .connected {
    background-color: var(--colours-support-warning);
  }
</style>
